import React from "react";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import { Translate } from "utils";

import styles from "./Ner.css";

const { t } = new Translate("Ner");

const Ner = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <Modal onClose={onClose} width={400} isOpen>
      <ModalHeader onClose={onClose}>{t("header")}</ModalHeader>
      <ModalBody>
        <div className={styles.title} dangerouslySetInnerHTML={{ __html: t("title") }} />
        <div className={styles.root}>
          <div className={styles.formulaWrapper}>
            <div className={styles.formula}>
              <div> NER =&nbsp;</div>
              <div>
                <div>&Sigma;[(A x P) x (T - f)] - C</div>
                <div className={styles.hr} />
                <div>T</div>
              </div>
            </div>
          </div>
          <div className={styles.legend}>
            <div>
              <div>A</div>
              {t("area")}
            </div>
            <div>
              <div>P</div>
              {t("price")}
            </div>
            <div>
              <div>T</div>
              {t("term")}
            </div>
            <div>
              <div>F</div>
              {t("free_rent_period")}
            </div>
            <div>
              <div>C</div>
              {t("costs")}
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

Ner.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Ner;
